import { AsyncState } from '../../../../store/types';
import * as types from './types';
import initialState from './intialState';

type Action = { type: string; payload?: unknown };

const defaultAction = { type: '' };

const updatePasswordReducer = (
  state = initialState.updatePassword,
  action: Action = defaultAction
): AsyncState => {
  switch (action.type) {
    case types.UPDATE_PASSWORD_BEGIN:
      return {
        ...initialState.updatePassword,
        isLoading: true
      };
    case types.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Record<string, unknown>
      };
    case types.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

export default updatePasswordReducer;
